package com.partejar.app.core.network

import com.partejar.app.feature.entitlements.data.CommercialConstraintException
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

@Serializable
private data class CommercialErrorDto(val code: String? = null)

/** The API code, rather than translated server text, drives commercial UX. */
suspend fun HttpResponse.commercialConstraintOrNull(): CommercialConstraintException? {
    val code = runCatching {
        Json { ignoreUnknownKeys = true }.decodeFromString<CommercialErrorDto>(bodyAsText()).code
    }.getOrNull() ?: return null
    return CommercialConstraintException(code)
}
